import * as React from "react";
import { connect } from "react-redux";
import * as cn from "classnames/bind";
import { publishTheme, unpublishTheme } from "./service";
import * as imagePickerStyles from "content/image/zenta-image-picker.css";
import * as themePickerStyles from "./theme-picker.css";
import { ApplicationState } from "store";
import { getResource } from "resource/store";

const cx = cn.bind({
    ...imagePickerStyles,
    ...themePickerStyles,
});

const ulCn = () =>
    cx({
        imagePickerUl: true,
    });

const liCn = () =>
    cx({
        imagePickerLi: true,
    });

const imageCn = (isSelected: boolean) =>
    cx({
        themeItem: true,
        imageItem: true,
        imageItemSelected: isSelected,
    });

const imageTextCn = () =>
    cx({
        imageText: true,
        "text-center": true,
    });

const checkboxCn = () =>
    cx({
        "form-check-label": true,
        interactable: true,
    });

export interface Theme {
    id: number;
    url: string | null;
    color: string | null;
    name?: string;
    published: boolean;
}

interface ZentaThemePickerProps {
    withAdminPanel?: boolean;
    selectedTheme: Theme | null;
    onUpdate?: () => void;
    onClick: (theme: Theme | null) => void;
    themes: Array<Theme>;
    Admin_Dashboard_Themes_New: string;
    Admin_Dashboard_Themes_Public: string;
}

class ZentaThemePicker extends React.Component<ZentaThemePickerProps> {
    private async togglePublished(theme: Theme) {
        await (theme.published
            ? unpublishTheme(theme.id)
            : publishTheme(theme.id));

        const { onUpdate } = this.props;

        if (onUpdate) {
            onUpdate();
        }
    }

    public render() {
        const {
            selectedTheme,
            withAdminPanel = false,
            onClick,
            themes,
        } = this.props;

        const isSelected = (theme: Theme, selectedTheme: Theme | null) => {
            if (!selectedTheme) {
                return false;
            }

            return theme.id === selectedTheme.id;
        };

        return (
            <ul className={ulCn()}>
                <li key={`new-theme`} className={liCn()}>
                    <div
                        className={imageCn(selectedTheme == null)}
                        onClick={() => onClick(null)}
                        style={{ margin: "auto" }}
                    />
                    <p
                        title={this.props.Admin_Dashboard_Themes_New}
                        className={imageTextCn()}>
                        {this.props.Admin_Dashboard_Themes_New}
                    </p>
                </li>

                {themes.map((theme, i) => (
                    <li
                        key={`${i}.${theme.url}.${theme.id}`}
                        className={liCn()}>
                        <div
                            title={theme.name}
                            className={imageCn(
                                isSelected(theme, selectedTheme),
                            )}
                            style={{
                                backgroundColor: theme.color || undefined,
                                backgroundImage: `url(${theme.url})`,
                                backgroundSize: "cover",
                                margin: "auto",
                            }}
                            onClick={() =>
                                onClick(
                                    isSelected(theme, selectedTheme)
                                        ? null
                                        : theme,
                                )
                            }
                        />

                        {theme.name && (
                            <p title={theme.name} className={imageTextCn()}>
                                {theme.name}{" "}
                                {withAdminPanel && (
                                    <div className={"form-check"}>
                                        <label className={checkboxCn()}>
                                            <input
                                                type={"checkbox"}
                                                className={"form-check-input"}
                                                checked={theme.published}
                                                onClick={this.togglePublished.bind(
                                                    this,
                                                    theme,
                                                )}
                                            />
                                            {
                                                this.props
                                                    .Admin_Dashboard_Themes_Public
                                            }
                                        </label>
                                    </div>
                                )}
                            </p>
                        )}
                    </li>
                ))}
            </ul>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    Admin_Dashboard_Themes_New: getResource(state, {
        key: "Admin_Dashboard_Themes_New",
    }),
    Admin_Dashboard_Themes_Public: getResource(state, {
        key: "Admin_Dashboard_Themes_Public",
    }),
});

export default connect(mapStateToProps)(ZentaThemePicker);
